import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllHistorial } from '../../../redux/actions';
import CardContainer from "../../../view/Tickets/HistorialTicket/CardsContainer";
import PacmanLoader from 'react-spinners/PacmanLoader';
import { FaHistory, FaSearch, FaInbox } from 'react-icons/fa';
import styles from '../GenerarTicket.module.css';

const HistorialTicket = () => {
  const dispatch = useDispatch();
  const usuario = useSelector((state) => state.usuario);
  const allticketced = useSelector((state) => state.allticketced);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [areaFilter, setAreaFilter] = useState('Todos');

  useEffect(() => {
    if (usuario && usuario.usuario && usuario.usuario.cedula) {
      dispatch(getAllHistorial(usuario.usuario.cedula))
        .then(() => {
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          if (err.response && err.response.status === 404) {
            setError('Usuario no tiene historial de tickets');
          } else {
            setError('Error al cargar los tickets');
          }
        });
    } else {
      setLoading(false);
      setError('Usuario no tiene historial de tickets');
    }
  }, [dispatch, usuario]);

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h2 className={styles.title}><FaHistory style={{ marginRight: '15px' }} /> Historial de Servicios</h2>
        <p className={styles.subtitle}>Consulta todos tus requerimientos cerrados o finalizados.</p>

        <div className={styles.filterContainer}>
          <div className={styles.searchWrapper}>
            <FaSearch className={styles.searchIcon} />
            <input
              type="text"
              placeholder="Buscar por # de ticket..."
              className={styles.searchInput}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <select
            className={styles.areaSelect}
            value={areaFilter}
            onChange={(e) => setAreaFilter(e.target.value)}
          >
            <option value="Todos">Todas las Áreas</option>
            <option value="Gest. TI">Gestión TI</option>
            <option value="Área Mto">Mantenimiento</option>
          </select>
        </div>
      </header>

      {loading ? (
        <div className={styles.spinnerContainer}>
          <PacmanLoader color="#3b82f6" loading={true} size={40} />
          <p style={{ color: 'white', marginTop: '20px', fontWeight: '600' }}>Cargando historial...</p>
        </div>
      ) : (
        error ? (
          <div className="alert alert-danger">{error}</div>
        ) : (() => {
          const tickets = allticketced?.tickets || [];
          const mantenimiento = allticketced?.mantenimiento || [];

          if (tickets.length === 0 && mantenimiento.length === 0) {
            return <div className="alert alert-info">No hay registros en tu historial.</div>;
          }

          // Filter by area
          let filteredTickets = tickets;
          let filteredMto = mantenimiento;

          if (areaFilter === "Gest. TI") {
            filteredMto = [];
          } else if (areaFilter === "Área Mto") {
            filteredTickets = [];
          }

          // Filter by search term
          if (searchTerm) {
            filteredTickets = filteredTickets.filter(t => t.TicketId?.toString().includes(searchTerm));
            filteredMto = filteredMto.filter(m => m.id?.toString().includes(searchTerm));
          }

          if (filteredTickets.length === 0 && filteredMto.length === 0) {
            return (
              <div className={styles.emptyState}>
                <FaSearch className={styles.emptyIcon} />
                <h3 className={styles.emptyTitle}>Sin coincidencias</h3>
                <p className={styles.emptySubtitle}>No se encontraron tickets en el historial que coincidan con tu búsqueda o filtro.</p>
              </div>
            );
          }

          return (
            <CardContainer
              allticketced={filteredTickets}
              mantenimiento={filteredMto}
              usuario={allticketced?.usuario || usuario.usuario}
            />
          );
        })()
      )}
    </div>
  );
};

export default HistorialTicket;
